import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=f41f8664&"
import script from "./Arrow.vue?vue&type=script&lang=js&"
export * from "./Arrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports